import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ActionBarComponent } from './action-bar.component';

@NgModule({
  declarations: [ActionBarComponent],
  imports: [CommonModule],
  exports: [ActionBarComponent]
})
export class ActionBarModule {}
